import PropTypes from "prop-types";
import withViewport from "../Viewport/withViewport";
import { withTranslation } from "@template/components/translation";
import classnames from "classnames";
import styles from "./index.css";
import NameRating from "./NameRating";
import AppLogo from "./AppLogo";
import DownloadAppButton from "./DownloadButton";

const AppDownload = ({
  isSideNavigation,
  formatTranslation,
  ctaRef,
  defaultStoreUrl
}) => (
  <section
    className={classnames(styles.container, {
      [styles.sideNavigation]: isSideNavigation
    })}
    data-testid="app-download"
  >
    <div className={styles.logoContainer}>
      <AppLogo classes={styles.appLogo} />
      <NameRating darkStars={isSideNavigation} />
    </div>
    <div className={styles.ctaContainer}>
      <DownloadAppButton
        ctaRef={ctaRef}
        defaultStoreUrl={defaultStoreUrl}
        classes={styles.ctaButton}
        theme="primary"
      >
        {formatTranslation("app_download_cta")}
      </DownloadAppButton>
    </div>
  </section>
);

AppDownload.propTypes = {
  isSideNavigation: PropTypes.bool,
  formatTranslation: PropTypes.func,
  ctaRef: PropTypes.string,
  defaultStoreUrl: PropTypes.string.isRequired
};

export default withViewport(withTranslation(AppDownload));
